module.exports = __webpack_public_path__ + "static/media/csc_logo.c8227835.svg";